module.exports = __webpack_public_path__ + "static/media/Ad_Alhamra.ee2d97bf.jpg";